<script lang="ts">
	import ViewPresentation from "./ViewPresentation.svelte";
	let { params = { id: "" } }: { params: { id: string } } = $props();
</script>

<ViewPresentation presentationId={params.id} />
